var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.359 11.7308C21.863 13.7889 21.6942 15.9544 20.8773 17.9096C20.0604 19.8647 18.6384 21.5066 16.8199 22.5944C15.0015 23.6821 12.8823 24.1584 10.7733 23.9535C8.66425 23.7486 6.6764 22.8731 5.1014 21.4556C3.52639 20.0381 2.44713 18.1532 2.02193 16.0773C1.59673 14.0014 1.84796 11.844 2.73881 9.92138C3.62966 7.99879 5.11326 6.4123 6.97185 5.39467C8.83045 4.37703 10.9662 3.98182 13.0659 4.26701",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83041 7.94675L12.7809 4.39076L9.04979 0.733314L12.3018 0.776621L16.0328 4.43407L12.0824 7.99006L8.83041 7.94675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.61ff3d70bb5049129679cd03cef54833.svg";
export { ForwardRef as ReactComponent };